//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from 'vuex';
import {
  faTimes,
  faFileDownload,
  faShareNodes,
  faQuestionCircle,
  faFlag,
} from '@fortawesome/pro-regular-svg-icons';
import productPageEventsMixin from '@motionelements/catalog/src/modules/product/mixins/product-page-events.mixin.js';
import featureFlagMixin from '@motionelements/core/src/components/mixins/feature-flag.mixin.js';
import { faMeSearchAi } from '@/assets/icons/me-font-icons-regular';

export default {
  name: 'ProductCtaButtonsMobileMenu',
  mixins: [productPageEventsMixin, featureFlagMixin],
  inject: {
    isPopUp: {
      default: false,
    },
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      faTimes,
      faFileDownload,
      faShareNodes,
      faMeSearchAi,
      faQuestionCircle,
      faFlag,
      //
      productSampleDownloading: false,
    };
  },
  computed: {
    ...mapState({
      isLoggedIn: state => state.user.isLoggedIn,
    }),
    ...mapGetters({
      isSimilaritySearchEnabled: 'product/isSimilaritySearchEnabled',
    }),
  },
  mounted() {
    this.$bus.$on('product-event-finished', this.handleProductEventFinished);
  },
  beforeDestroy() {
    this.$bus.$off('product-event-finished', this.handleProductEventFinished);
  },
  methods: {
    showShareModal() {
      this.close();
      setTimeout(() => {
        this.$bvModal.show('share-product-modal');
      }, 200);
    },
    close() {
      this.$store.commit('app/toggleOverlay', false);
      this.$store.commit('app/toggleCtaMobileMenu', false);
    },
    onClickSimilar() {
      this.emitProductEvent('product-similar-search', { product: this.product });
    },
    onClickDownloadSample() {
      this.productSampleDownloading = true;
      this.emitProductEvent('product-sample-download', { product: this.product });
    },
    handleProductEventFinished({ event }) {
      console.log('======== product event finished ', event);
      if (event === 'product-sample-download') {
        this.productSampleDownloading = false;
        this.close();
      }
    },
    showFlagProductModal() {
      if (!this.isPopUp) this.close();
      this.$bvModal.show('flag-product-modal');
    },
  },
};
